export default Object.freeze({
    GOAL: 'Goal',
    OUTFLOW: 'Outflow'
});